/**
 * Format a number as currency with the given symbol
 */
export const formatPrice = (price, currencySymbol = '') => {
  if (price == null || isNaN(price)) return '—';
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
  return currencySymbol ? `${formatted} ${currencySymbol}` : formatted;
};

/**
 * Format percentage change
 */
export const formatChange = (change) => {
  if (change == null || isNaN(change)) return '0.00%';
  return `${Math.abs(change).toFixed(2)}%`;
};

/**
 * Format price change amount
 */
export const formatChangeAmount = (change, currencySymbol = '') => {
  if (change == null || isNaN(change)) return `0.00 ${currencySymbol}`;
  return `${Math.abs(change).toFixed(2)} ${currencySymbol}`;
};

/**
 * Troy ounce to grams constant (exact)
 */
const TROY_OUNCE_GRAMS = 31.1035;

/**
 * Calculate gold price per gram from price per ounce
 */
export const ouncesToGrams = (pricePerOunce) => {
  if (!pricePerOunce) return 0;
  return pricePerOunce / TROY_OUNCE_GRAMS;
};


/**
 * Format date/time for display in Arabic
 */
export const formatDateTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  return date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
